import { useCallback } from 'react';

import { useAtom } from 'jotai';
import { useResetAtom } from 'jotai/utils';

import { playback3dFreezePositionAtom, playback3dSelectedParamsAtom } from '@store';

export function useVisualizationParams() {
    const [freezePosition, setFreezePosition] = useAtom(playback3dFreezePositionAtom);
    const handleClearVisualization = useResetAtom(playback3dSelectedParamsAtom);

    const handleFreezePosition = useCallback(
        (position: string | null) => {
            setFreezePosition(position);
        },
        [setFreezePosition],
    );

    return {
        freezePosition,
        handleFreezePosition,
        handleClearVisualization,
    };
}
